import { CRM } from "@/components/atomic-crm/root/CRM";

/**
 * Application entry point
 *
 * Customize Atomic CRM by passing props to the CRM component:
 *  - contactGender
 *  - companySectors
 *  - darkTheme
 *  - dealCategories
 *  - dealPipelineStatuses
 *  - dealStages
 *  - lightTheme
 *  - logo
 *  - noteStatuses
 *  - taskTypes
 *  - title
 * ... as well as all the props accepted by shadcn-admin-kit's <Admin> component.
 *
 * @example
 * const App = () => (
 *    <CRM
 *       logo="./img/logo.png"
 *       title="Acme CRM"
 *    />
 * );
 */
const App = () => (
  <CRM
    lightModeLogo="./logos/cybercloak-logo.svg"
    darkModeLogo="./logos/cybercloak-logo.svg"
    title="CyberCloak CRM"
    dealCategories={[
      "Fractional CMO Work",
      "Fractional CTO/CIO Work",
      "Fractional CISO Work",
      "vCISO Retainer",
      "WebSite",
      "Software Development",
      "Marketing Program",
      "Security Audit",
      "Penetration Testing",
      "Risk Assessment",
      "Compliance Assessment",
      "Security Operating Center (ZTLayer)",
      "Managed Services",
      "Incident Response",
      "Security Awareness Training",
      "Risk 5X5",
      "Other",
    ]}
  />
);

export default App;
